import { styled } from '@mui/system';
import { Popover as PopoverMui } from '@mui/material';
import { theme } from 'oems/theme';

export const Wrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
`;

export const Popover = styled(PopoverMui)`
  .MuiPaper-root {
    padding: 0;
  }
`;

export const DropdownContent = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: white;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.17);
  border-radius: 6px;
`;

export const Menu = styled('div')`
  padding: 8px;
  width: 212px;
`;

export const MenuButton = styled('button')`
  font-family: ${theme.typography.fontFamily};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: left;
  height: 35px;
  padding: 0 14px;
  color: ${theme.palette.text.dark};
  border: none;
  background: white;
  font-size: 14px;
  cursor: pointer;

  &.login {
    margin: 0 16px;
  }

  &:hover {
    color: ${theme.palette.text.focus};
  }
`;
